<div class="p500-ui-modal__inner">
  <form class="c-form c-form--d" [formGroup]="form">
    <div class="c-modal__head">
      <div class="row">
        <div class="c-modal__close" (click)="close()">
          <p500-ui-icon name="close" size="20px"></p500-ui-icon>
        </div>
        <div class="c-modal__title col-12">
          {{ data.id ? config.getEditTitle() || config.getTitle() : config.getTitle() }}<span *ngIf="data.id">&nbsp;#{{ data.id }}</span>
        </div>
        <div class="c-modal__subtitle col-12">
          {{ data.id ? config.getEditDescription() || config.getDescription() : config.getDescription() }}
        </div>
      </div>
    </div>

    <div class="p500-ui-modal__body">
      <p500-ui-cube-preloader [hidden]="!isLoading"></p500-ui-cube-preloader>

      <div *ngIf="config.getBodyText() && !isLoading">{{ config.getBodyText() }}</div>

      <div [hidden]="isLoading">
        <div [formGroup]="form" class="row" *ngIf="form">
          <ng-container *ngIf="components | keyvalue: originalOrder as components">
            <ng-container *ngFor="let field of components; let i = index; trackBy: trackByFn">
              <div
                *ngIf="field.value"
                class="c-form__section"
                gtdFieldWidth
                [grid]="config.getGrid()"
                [fieldIDx]="i"
                [fields]="components.length"
                [hidden]="dependHideFields[field.key] && (dependHideFields[field.key] | async)"
              >
                <p500-ui-control-dynamic-component [component]="field.value" [settings]="componentsSettings.get(field.key)" #dynamic>
                </p500-ui-control-dynamic-component>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="c-modal__footer" [ngClass]="toggleField ? 'justify-content-between' : 'justify-content-end'">
      <div *ngIf="toggleField">
        <p500-ui-slide-toggle-field
          [formControl]="toggleField?.formControl"
          [isLabelRight]="false"
          [label]="toggleField?.label || defaultSwitcherText"
          size="medium"
        >
        </p500-ui-slide-toggle-field>
      </div>

      <div class="d-flex">
        <div class="c-modal__action" (click)="close();$event.preventDefault()">
          <button type="button" p500-ui-button stroked="true" i18n="@@common.cancel">Cancel</button>
        </div>
        <div class="c-modal__action">
          <button
            type="submit"
            p500-ui-button
            classIcon="p500-ui-icon-check"
            positionIcon="right"
            [disabled]="form.invalid || isLoading"
            (click)="submit()"
          >
            {{ config.getBtnCaption() }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
